import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import UnitForm from './UnitForm';
import { addUnit } from '../../services/unitService';

function UnitAdd(props) {
  const initialValues = {
    code: '',
    title: '',
    description: '',
    longDescription: '',
    subunits: []
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    console.log('Initial value', initialValues);
    let payload = {
      ...values
    };

    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    await addUnit(payload)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Add Unit`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <UnitForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
          setStatus={setStatus}
        />
      )}
    </Modal>
  );
}

export default UnitAdd;
